import { Button } from '~/components/common/Button'
import { MdOutlineExpandLess } from '@react-icons/all-files/md/MdOutlineExpandLess'
import { MdOutlineExpandMore } from '@react-icons/all-files/md/MdOutlineExpandMore'
import { useEffect, useRef, useState } from 'react'
import { cm } from '~/utils/utils'
import './Document.scss'
import { LexicalEditorComponenet } from './LexicalEditor'

interface DocumentProps {
  index: number
  _uuid?: string
}

const Document: React.FC<DocumentProps> = ({ index, _uuid }) => {
  const [isExpanded, setIsExpanded] = useState(false)
  const [needExpand, setNeedExpand] = useState(true)
  const editorRef = useRef<HTMLDivElement | null>(null)

  useEffect(() => {
    if (editorRef.current) {
      const needExpand = editorRef.current.scrollHeight > editorRef.current.clientHeight
      setNeedExpand(needExpand)
    }
  }, [editorRef.current])

  const toggleExpand = () => {
    setIsExpanded(prev => !prev)
  }
  return (
    <div
      className={cm(
        'w-[1000px] border mt-6 -translate-x-10 bg-white relative transition-all duration-300',
        isExpanded ? 'h-auto pb-10' : 'max-h-[500px] overflow-y-hidden',
        'document'
      )}
    >
      {needExpand && !isExpanded ? (
        <div className={cm('absolute bottom-0 left-0 w-full h-[165px] box z-10')}></div>
      ) : null}

      {needExpand && (
        <div className='absolute bottom-2 w-full h-8 flex items-center justify-center text-black z-20 '>
          <Button variant='secondary' onClick={toggleExpand}>
            {isExpanded ? (
              <div className='flex items-center'>
                Hide
                <MdOutlineExpandLess size={24} className='ml-1' />
              </div>
            ) : (
              <div className='flex items-center'>
                Expand
                <MdOutlineExpandMore size={24} className='ml-1' />
              </div>
            )}
          </Button>
        </div>
      )}
      <div className={cm('my-4 top-2', isExpanded ? 'h-full' : 'h-[440px]')}>
        <LexicalEditorComponenet key='doc' editorRef={editorRef} index={index} _uuid={_uuid} />
      </div>
    </div>
  )
}

export default Document
